import axios from '@src/utils/axios'

const module = 'role'
const axiosInstance = axios(false);

export default {
  'paginate': (ctx, data) => axiosInstance.get(`/${module}`, {params:data}),
  'get': (ctx, data) => axiosInstance.get(`/${module}/dropdown`, { params: data }),
  'get_modules': () => axiosInstance.get(`/${module}/get_modules`),
  'find': (ctx, data) => axiosInstance.get(`/${module}/${data.id}`),
  'create': (ctx, data) => axiosInstance.post(`/${module}`, data),
  'update': (ctx, data) => {
    return axiosInstance.put(`/${module}/` + data.id, data)
  },
}